import classNames from 'classnames';
import { forwardRef } from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from '@/shared/components/shared/Image';
import Responsive from '@/shared/components/shared/Responsive';
import { useMounted } from '@/shared/hooks/use-mounted';
import { ImageShape } from '@/shared/lib/types';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        images: ImageShape[];
    };
};

const ConstructorSlider = forwardRef<HTMLDivElement, Props>(({ properties: { images }, ...props }, ref) => {
    const isMounted = useMounted();

    return (
        <div {...props} ref={ref} className={classNames('constructor-block constructor-slider', props.className)}>
            {isMounted && (
                <Swiper
                    className="constructor-slider-el"
                    modules={[Autoplay]}
                    speed={800}
                    autoplay
                    slidesPerView="auto"
                    breakpoints={{
                        320: {
                            slidesPerView: 'auto',
                            spaceBetween: 8,
                            centeredSlides: true,
                        },
                        769: {
                            slidesPerView: 'auto',
                            spaceBetween: 12,
                            centeredSlides: true,
                        },
                        1201: {
                            centeredSlides: false,
                            slidesPerView: 2.6,
                            spaceBetween: 20,
                        },
                        1921: {
                            slidesPerView: 'auto',
                            spaceBetween: 20,
                        },
                    }}
                    loop={true}
                >
                    {images.map((slide, i) => {
                        return (
                            <SwiperSlide className="constructor-slider-slide" key={i}>
                                <Responsive>
                                    <Image
                                        className="constructor-slider-img"
                                        src={slide.src}
                                        width={slide.width}
                                        height={slide.height}
                                        alt=""
                                    />
                                </Responsive>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}

            <div className="constructor-slider-card responsive">
                <div className="responsive__item"></div>
            </div>
        </div>
    );
});

ConstructorSlider.displayName = 'ConstructorSlider';

export default ConstructorSlider;
